import {
  generalTerm,
} from '@/constants/locales/en.shared.ts';

export default {
  setpoints: {
    header: 'Setpoints',
  },
  properties: {
    header: 'Properties',
    representativeCouponDiameterLabel: generalTerm.representativeDiameter,
    halfInfiniteRadio: 'Half-infinite',
    shapeOrientedRadio: 'Shape oriented',
  },
  carburizing: {
    header: 'Carburizing',
  },
  nitriding: {
    header: 'Nitriding',
    preNitridedCondition: 'Pre-Nitrided Condition',
    estimatedTemperingConditions: 'Estimated tempering conditions',
  },
  isnitridingHardnessEffective: {
    true: 'Effective',
    false: 'Core +',
  },
  materialSimulationData: {
    header: 'Material simulation data',
  },
  savePartAs: {
    header: 'Save part as',
  },
  newPartDisplayName: 'New part',
  cContent: 'C-Content in wt%',
  nContent: 'N-Content in wt%',
  cnContent: 'C/N-Content in wt%',
  depthCore: 'Depth of core in mm',
  depth: 'Depth in mm',
  preprocessedProfile: 'Preprocessed profile',
  parametrizedProfile: 'Parametrized profile',
  parametrizedProfileDescription: 'Define the profile of your part by specifying surface and core content.',
  surfaceContent: 'Surface content',
  coreContent: 'Core content',
  setpointsDescription: 'Extent the profile by providing explicit values.',
  surfaceHardnessCannotBeAchieved: 'This surface hardness cannot be achieved',
};
